import { render, staticRenderFns } from "./MatterContributionView.vue?vue&type=template&id=140ffeae&scoped=true"
import script from "./MatterContributionView.vue?vue&type=script&lang=js"
export * from "./MatterContributionView.vue?vue&type=script&lang=js"
import style0 from "./MatterContributionView.vue?vue&type=style&index=0&id=140ffeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ffeae",
  null
  
)

export default component.exports